import Seo from "../lib/seo";
import { MaskedLines } from "../components/motion";
import { PrimaryCta, SecondaryCta } from "../components/ui-bits";

export default function NotFound() {
  return (
    <>
      <Seo title="404 — Page Not Found | GeoDrafts" description="This coordinate doesn't match any page on GeoDrafts." path="/404" />
      <section className="relative bg-navy-deep min-h-[80vh] flex items-center overflow-hidden" data-testid="not-found-page">
        <div className="absolute inset-0 bg-contours-dark" aria-hidden="true" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-28 relative">
          <p className="font-mono text-xs tracking-[0.3em] text-aqua uppercase" data-testid="not-found-code">Error 404 · Coordinate Out of Bounds</p>
          <MaskedLines
            lines={["This benchmark", "doesn't exist."]}
            delay={0.1}
            className="mt-5 text-5xl sm:text-6xl font-extrabold text-white leading-[1.08]"
          />
          <p className="mt-6 text-lg text-white/60 max-w-md">
            The page you're looking for doesn't match any survey point on this site. Let's get you back to known coordinates.
          </p>
          <p className="mt-5 font-mono text-[11px] tracking-widest text-white/40 uppercase">Lat 0.0000° · Long 0.0000° · Elev —</p>
          <div className="mt-9 flex flex-wrap gap-4">
            <PrimaryCta to="/" dark testid="not-found-home">Return Home</PrimaryCta>
            <SecondaryCta to="/land-survey-cad-drafting" dark testid="not-found-services">View Services</SecondaryCta>
          </div>
        </div>
      </section>
    </>
  );
}
